export var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["GLS"] = "GLS";
    ShippingMethod["SHOP"] = "shop";
    ShippingMethod["BPOST"] = "bpost";
})(ShippingMethod || (ShippingMethod = {}));
